// Ported from dev-scrips-pm-react services/scheduling/use-retrieve-end-date.ts (PROD-1190 calendar port)
import { useMutation } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';

/**
 * POST /api/Appointment/RetrieveEndDate
 *
 * Mirrors Flutter `retrieveEndDate()` →
 * `scheduling_data_source_impl.dart:1002-1022`. Returns the recurrence
 * end date as an ISO string (Flutter strips quotes from the response).
 *
 * Body shape mirrors `RecurrenceProperties.retrieveEndDateJson()`
 * (recurrence_properties_model.dart:114-122) — only `days` is included
 * when the period is "Weeks".
 */

export interface RetrieveEndDateParams {
  startDate: string;
  repeatEvery: number;
  numberOfRepeat: number;
  /** Backend period enum — "Days" | "Weeks" | "Months". */
  period: string;
  /** Full weekday names ("Monday", "Tuesday", …). Flutter only sends
   * this when `period === "Weeks"`. */
  days?: string[];
}

function buildBody(params: RetrieveEndDateParams) {
  return {
    startDate: params.startDate,
    repeatEvery: params.repeatEvery,
    numberOfRepeat: params.numberOfRepeat,
    period: params.period,
    days: params.period === 'Weeks' ? (params.days ?? []) : null,
  };
}

export function useRetrieveEndDate() {
  return useMutation<string, Error, RetrieveEndDateParams>({
    mutationFn: async (params) => {
      const raw = await post<string>('/api/Appointment/RetrieveEndDate', buildBody(params));
      // Flutter does `.replaceAll('"', '')` because the endpoint returns
      // a quoted string literal. Mirror that here defensively.
      return typeof raw === 'string' ? raw.replace(/^"|"$/g, '') : raw;
    },
  });
}
